import LocationSelect from './LocationSelect';

export default LocationSelect;
